<template>
<v-card>
  <v-card-title class="secondary white--text">
    <v-btn small dark icon>
      <v-icon>fa-blank</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
    <h5>My Progress</h5>
    <v-spacer></v-spacer>
    <v-btn small dark icon @click="$eventBus.$emit('play_video',$store.state.app.tutorials.progress['My Progress'])">
      <v-icon>fa-question</v-icon>
    </v-btn>
  </v-card-title>
  <v-container>

    <v-row justify="center">
      <v-col cols="6" sm="3" md="3" lg="3" xl="3" v-for="(category,i) in current_rank_stars" :key="i">
        <div :class="`text-center pa-2 rank-star rank-${$store.state.account.account.rank}-star`">
          <v-icon large v-if="category>=5">fas fa-star</v-icon>
          <v-icon large v-else>far fa-star</v-icon>
        </div>
        <div class="progress-outter">
          <div :class="`progress-content rank-${$store.state.account.account.rank}-bg`" :style="`width: ${Math.round(category/5 * 100) > 100 ? 100 : Math.round(category/5 * 100)}%;`"></div>
          <span class="progress-text" :title="category">{{categories[i].label}}</span>
        </div>
      </v-col>
    </v-row>
    <v-row>

    </v-row>
  </v-container>
</v-card>
</template>
<script>
export default {
  name: "",
  props: ['projects'],
  data: () => ({

  }),
  computed: {
    categories() {
      return this.$store.state.app.project_report_categories
    },
    current_rank_stars: function() {
      let categories = {};
      for (var category in this.categories) {
        categories[category] = 0;
      }

      this.projects.filter(function(p) {
        if (p.status!==11){
          return false
        }
        return p.rank === this.$store.state.account.account.rank && p.report
      }.bind(this)).forEach(function(p) {
        for (var category in p.report.score) {
          categories[category] += p.report.score[category][this.$store.state.account.account.rank - 1].reduce((c, j) => c + j, 0) === p.report.score[category][this.$store.state.account.account.rank - 1].length
        }
      }.bind(this))
      return categories;
    },
  }
}
</script>
<style lang="scss" scoped>
.bigicon {
    font-size: 500px;
}
</style>
